import {
	Box,
	Button,
	Divider,
	FormControl,
	FormControlLabel,
	FormHelperText,
	Grid,
	InputLabel,
	MenuItem,
	OutlinedInput,
	Select,
	Stack,
	Autocomplete,
	Checkbox,
} from "@mui/material";
import DvrIcon from "@mui/icons-material/Dvr";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import React from "react";
import { sizes } from "../analyzeUtils";
import ActiveScenariosCheckbox from "./ActiveScenariosCheckbox";
import { useDispatch, useSelector } from "react-redux";
import {
	getChartDataForData,
	getScenariosData,
	getSkuPgData,
	setState,
	getCustomersData,
} from "../analyzeSlice";
import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";
import MultiSelectProducts from './MultiSelectProducts';
import MultiSelectCustomers from './MultiSelectCustomers';
import TvIcon from "@mui/icons-material/Tv";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;
/** Same height as MultiSelectProducts / MultiSelectCustomers in this row */
const multiSelectRowHeight = 44;

export default function DataForm() {
	const [countryData, setCountryData] = useState("");
	const [scenarioData, setScenarioData] = useState("");
	const[triggerEffect, setTriggerEffect] = useState(false);
	const [includeCurrentPeriod, setIncludeCurrentPeriod] = useState(false);
	const [monthsInput, setMonthsInput] = useState("");
	const [monthsError, setMonthsError] = useState(false);

	const [alert, setAlert] = useState({
		alertSeverity: "",
		alertDisplay: false,
		alertMessage: ""
	});

	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze); 
	const {
		countries,
		selectedCountry,
		selectedCountryID,

		isActiveScenario,

		selectedAnalysisTypeID,

		scenariosData,
		selectedScenarioName,
		selectedScenarioID,

		skuPgsData,
		selectedSkuPgName,
		selectedSkuPgID,
		customersData,

		duration,
		selectedDataCustomerIds,
		customerList,
		selectedDataProductIds,
		allCustomersSelected,
	} = state;

	const loginState = useSelector((store) => store.login);
	const { globalSelectedCountryName,globalSelectedCountryID,} = loginState 
	
	useEffect(() => {
		if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
		  dispatch(setState("selectedCountry", globalSelectedCountryName));
		  dispatch(setState("selectedCountryID", globalSelectedCountryID));
		  setCountryData(globalSelectedCountryName);
		}
	},[globalSelectedCountryID]);	

	const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
	const checkedIcon = <CheckBoxIcon fontSize="small" />;

	useEffect(() => {
		if(globalSelectedCountryName ==null || globalSelectedCountryName == "" || globalSelectedCountryName ==undefined ){
		dispatch(setState("selectedCountry", ""));
		}
		// dispatch(setState("selectedCountryID", "null"));

		dispatch(setState("selectedScenarioName", ""));
		// dispatch(setState("selectedScenarioID", null));
		dispatch(setState("selectedDataCustomerIds", []));
		dispatch(setState("customerList", []));
		dispatch(setState("selectedDataProductIds", []));
		
		dispatch(setState("duration", null));
		setMonthsInput("");
		setMonthsError(false);
		dispatch(setState("clearAnalyzeData", false));

		dispatch(setState("scenariosData", []));
		dispatch(setState("skuPgsData", []));
		dispatch(setState("customersData", []));

		dispatch(setState("clearDataValues", true));

		setIncludeCurrentPeriod(false);

		}, [])

	const clearValues = () => {
		dispatch(setState("clearDataValues", true));
		dispatch(setState("selectedDataCustomerIds", []));
		dispatch(setState("customerList", []));
		dispatch(setState("selectedDataProductIds", []));
		setIncludeCurrentPeriod(false);
		//dispatch(setState("duration", ""));		
	}

	function handleMonthsChange(event) {
		const digits = event.target.value.replace(/\D/g, "").slice(0, 2);
		setMonthsInput(digits);
		dispatch(setState("searchFilterText", ""));

		if (digits === "") {
			dispatch(setState("duration", null));
			setMonthsError(false);
			return;
		}

		const n = parseInt(digits, 10);
		if (Number.isNaN(n)) {
			dispatch(setState("duration", null));
			setMonthsError(false);
			return;
		}

		if (n < 1) {
			dispatch(setState("duration", null));
			setMonthsError(digits.length > 0);
			return;
		}

		if (n > 36) {
			dispatch(setState("duration", null));
			setMonthsError(true);
			return;
		}

		setMonthsError(false);
		dispatch(setState("duration", n));
	}

	function handleMonthsBlur() {
		if (monthsInput === "") {
			setMonthsError(false);
			return;
		}
		const n = parseInt(monthsInput, 10);
		if (Number.isNaN(n) || n < 1 || n > 36) {
			setMonthsError(true);
			dispatch(setState("duration", null));
		}
	}


	useEffect(() => {
		if (countryData !== "") {
			getScenariosForCountry();
		}
	}, [countryData]);

	useEffect(() => {
		if (scenarioData !== "") {
			getSkuPgForScenario();
		}
	}, [scenarioData,triggerEffect]);



	function setCountry(event) {
		const name = event.target.value;
		const countryID = countries.find(
			(country) => country.countryName === name
		).countryID;

		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", countryID));
		//dispatch(setState("selectedScenarioName", ""));
		dispatch(setState("scenariosData", []));
		dispatch(setState("selectedScenarioName", ""));
		dispatch(setState("selectedScenarioID", ""));
	
		dispatch(setState("scenariosData", []));
		dispatch(setState("skuPgsData", []));
		dispatch(setState("customersData", []));

		setCountryData(name);	
		clearValues();
		dispatch(setState("selectedScenarioID", ""));
		dispatch(setState("clearAnalyzeData", false));		
		dispatch(setState("searchFilterText",""));	
	}

	function getScenariosForCountry() {
		const countryID = selectedCountryID;
		const activeScenario = isActiveScenario;
		const analyisID = selectedAnalysisTypeID;
		const obj = {
			countryID,
			activeScenario,
			analyisID,
		};
		dispatch(getScenariosData(obj));
	}

	function setScenario(event) {
		const id = event.target.value;
		const name = scenariosData?.find(
			(scenario) => scenario.scenarioID === id
		).scenarioName;
		dispatch(setState("selectedScenarioName", name));
		dispatch(setState("selectedScenarioID", id));
console.log("selectedScenarioID", scenarioData);

		
		setScenarioData(id);
		setTriggerEffect((Prev)=>!Prev);
		

		clearValues();
		dispatch(setState("clearAnalyzeData", false));
		dispatch(setState("searchFilterText",""));
	}

	function getSkuPgForScenario() {
		const scenarioID = selectedScenarioID;
		const obj = {
			scenarioID,
		};
		dispatch(getSkuPgData(obj));
		dispatch(getCustomersData(obj));
	}

	function setSkuPg(event) {
		const name = event.target.value;
		const id = skuPgsData.find(
			(skuPg) => skuPg?.packGroupOrSKUName === name
		).packGroupOrSKUID;
		dispatch(setState("selectedSkuPgName", name));
		dispatch(setState("selectedSkuPgID", id));
	}

	// useEffect(() => {
	// 	//Check if any of the dropdown are false and then set alertDisplay to false
	// 	const isAnyKeyValueFalse = o => !!Object.keys(o).find(k => !o[k]);

	// 	if (isAnyKeyValueFalse(validate)) {
	// 		setAlert({ ...Alert, alertDisplay: false });
	// 	}
	// }, [validate])


	const displayAlert = (severityType) => {
		setAlert({
			"alertSeverity": "warning",
			"alertDisplay": true,
			"alertMessage": `Please select the ${severityType}`
		});

		setTimeout(() => {
			clearAlert();
		},[2000])
		
	}

	const clearAlert = () => {
		setAlert({
			"alertSeverity": "",
			"alertDisplay": false,
			"alertMessage": ``
		});
	}
	const getCustomerIdsFromNames = (customerNames) => {


		const uniqueKeys = new Map();
		for (const item of customersData) {
			const key = `${item.customerName}`;
			uniqueKeys.set(key, item.customerID);
		}
		
		const customerIds = [];
		
		for (const item of customerNames) {
			const key = `${item}`;
			if (uniqueKeys.has(key)) {
				customerIds.push(uniqueKeys.get(key));
			} else {
				customerIds.push(item);
			}
		}
		return customerIds.filter((id) => id !== null);

	};

	const handleDisplay = () => {
		if (selectedCountry === null || selectedCountry === "") {
			displayAlert("Country");
			return;
		}
		if (selectedScenarioName === null || selectedScenarioName === "") {
			displayAlert("Scenario");
			return;
		}
		if (selectedDataProductIds.length === 0) {
			displayAlert("SKU / PG");
			return;
		}
		if (customerList.length === 0) {
			displayAlert("Customer");
			return;
		}
		if (duration === null || duration === "" || monthsError) {
			displayAlert(monthsError ? "number of months (1–36)" : "Duration");
			return;
		}
		dispatch(setState("isLoading", true));
		const timer = setTimeout(() => {
		let ids = [];
		if(allCustomersSelected){
			ids = [];
		}else{
			if (customerList.length > 0) {
				ids = getCustomerIdsFromNames(customerList);
				//dispatch(setState("clearDataValues", false));
			}
			else {
				ids = [];
			}
		}
		dispatch(setState("selectedDataCustomerIds", ids));
		const scenarioID = selectedScenarioID;
		const skuPgID = selectedSkuPgID;
		const obj = {
			customerIds: ids,
			duration: duration,
			includeCurrentPeriod: includeCurrentPeriod ? 1 : 0,
			isAllCustomerSelected: allCustomersSelected,
			productIds: selectedDataProductIds,
			scenarioID: selectedScenarioID,
		};

		//Alert if any of the dropdowns are not validated
			dispatch(setState("clearAnalyzeData", true));
		
			dispatch(getChartDataForData(obj));
		//dispatch(getChartDataForData(obj));
	},10);
	}

	return (
		<Box sx={{ mt: 4 }}>
			<Grid container
				columnGap={3}
				rowGap={3}
				alignContent={"space-between"}
				alignItems="flex-start"
			>
				<Grid item sm={6} md={4} lg={2}>
					<FormControl >
						<InputLabel>Country</InputLabel>
						<Select
							value={countryData}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setCountry}
						>
							{countries.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
					<ActiveScenariosCheckbox />
				</Grid>

				<Grid item
				 sm={6} md={4} lg={1.8}
				>
					<FormControl>
						<InputLabel>Scenario</InputLabel>
						<Select
							value={selectedScenarioID}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setScenario}
						>
							{scenariosData?.map((scenario, index) => {
								return (
									<MenuItem key={index} value={scenario.scenarioID}>
										{scenario.scenarioName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item
				// sm={6} md={4} lg={1.5}
				>
					<MultiSelectProducts skuPgs={skuPgsData} />
				</Grid>

				<Grid item
				// sm={6} md={4} lg={1.5}
				>
					<MultiSelectCustomers customers={customersData} />
				</Grid>

				<Grid item sm={6} md={4} lg={1.8}>
					<Stack
						spacing={0.75}
						sx={{
							width: "100%",
							maxWidth: "100%",
							pt: 0,
							mt: 0,
						}}
					>
						<Stack
							direction="row"
							spacing={1.25}
							alignItems="center"
							sx={{
								width: "100%",
								minHeight: multiSelectRowHeight,
							}}
						>
							<FormControl
								variant="outlined"
								error={monthsError}
								sx={{
									flex: "0 0 132px",
									width: 132,
									color: "black.main",
									mt: 0,
									mb: 0,
								}}
							>
								<InputLabel htmlFor="analyze-data-months-input">
									Number of months
								</InputLabel>
								<OutlinedInput
									id="analyze-data-months-input"
									label="Number of months"
									value={monthsInput}
									onChange={handleMonthsChange}
									onBlur={handleMonthsBlur}
									aria-describedby="analyze-data-months-helper"
									inputProps={{
										inputMode: "numeric",
										pattern: "[0-9]*",
										"aria-label": "Number of months from 1 to 36",
									}}
									sx={{
										height: multiSelectRowHeight,
										color: "black.main",
										"& .MuiOutlinedInput-input": {
											py: 0,
											height: multiSelectRowHeight,
											boxSizing: "border-box",
											display: "flex",
											alignItems: "center",
										},
									}}
								/>
							</FormControl>
							<Box
								sx={{
									flex: 1,
									minWidth: 0,
									minHeight: multiSelectRowHeight,
									display: "flex",
									alignItems: "center",
									pl: 0.5,
								}}
							>
								<FormControlLabel
									control={
										<Checkbox
											checked={includeCurrentPeriod}
											onChange={(e) =>
												setIncludeCurrentPeriod(e.target.checked)
											}
											color="primary"
											size="small"
											sx={{ p: 0.5 }}
										/>
									}
									label="Include current period"
									sx={{
										m: 0,
										mr: 0,
										ml: 0,
										display: "flex",
										alignItems: "center",
										width: "100%",
										"& .MuiFormControlLabel-label": {
											fontSize: "0.875rem",
											lineHeight: 1.2,
											color: "black.main",
											whiteSpace: "nowrap",
										},
									}}
								/>
							</Box>
						</Stack>
						<FormHelperText
							id="analyze-data-months-helper"
							component="div"
							error={monthsError}
							sx={{ mx: 0, mt: 0 }}
						>
							{monthsError
								? "Enter a whole number from 1 to 36"
								: "1-36 month"}
						</FormHelperText>
					</Stack>
				</Grid>

				{/* <Grid item
				// sm={6} md={4} lg={2}
				>
					<ActiveScenariosCheckbox />
				</Grid> */}
				<Grid
					item
					sm={6}
					md={4}
					lg={2}
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						alignItems: "flex-start",
						alignSelf: "flex-start",
						ml: { xs: 0, lg: "auto" },
						pt: 0,
					}}
				>
					<Button
						startIcon={<TvIcon />}
						sx={{
							bgcolor: "darkred.light",
							color: "white.main",
							textTransform: "none",
							fontWeight: "bold",
							"&:hover": {
								bgcolor: "darkred.main",
							},
						}}
						onClick={() => handleDisplay()}
					>
						Display
					</Button>
				</Grid>
			</Grid>
			{alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}
			<Divider sx={{ mt: 3 }} />
		</Box>
	);
}